import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=6818dde9&scoped=true"
import script from "./GridCard.vue?vue&type=script&lang=ts"
export * from "./GridCard.vue?vue&type=script&lang=ts"
import style0 from "./GridCard.vue?vue&type=style&index=0&id=6818dde9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818dde9",
  null
  
)

export default component.exports